import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginWithGoogle } from "../Actions/user";

const useAuthFacade = () => {
    const [showAlert, setShowAlert] = useState(false);
    const dispatch = useDispatch();
    const { loading, isAuthenticated, error } = useSelector((state) => state.user);

    const handleGoogleLogin = () => {
        dispatch(loginWithGoogle());
    };

    // Clear any stale auth error when login page mounts (e.g. from loadUser failing when not logged in)
    useEffect(() => {
        dispatch({ type: "ClearAuthError" });
    }, [dispatch]);

    useEffect(() => {
        if (error) {
            setShowAlert(true);
        }
    }, [error]);

    const handleOnClose = () => {
        if (error) {
            dispatch({ type: "ClearAuthError" });
        }
        if (isAuthenticated) {
            window.location.href = "/";
        }
        setShowAlert(false);
    };

    return {
        loading,
        isAuthenticated,
        showAlert,
        setShowAlert,
        handleGoogleLogin,
        handleOnClose,
    };
};

export default useAuthFacade;
